module.exports = __webpack_public_path__ + "static/img/activity1.c4793e67.png";